export const substanceReducer = (
	state = {
		listData: [],
		countData: 0
	},
	action
) => {
	switch (action.type) {
		case "SUBSTANCE_LIST":
		case "SUBSTANCE_SUCCESS":
			return {
				...state,
				listData: action.payload.list,
				countData: action.payload.count,

			};

		default:
			return state;
	}
};
